import {
  FeatureServiceBinder,
  FeatureServiceProviderDefinition,
  SharedFeatureService,
} from '@feature-hub/core';
import {createObservable} from './v1/create-observable';
import {FeatureappServiceV1} from './v1/featureapp-service-v1';

export interface FeatureappService extends SharedFeatureService {
  readonly '1.6.0': FeatureServiceBinder<FeatureappServiceV1>;
}
export interface CssRef {
  media?: string;
  href: string;
}

export interface FeatureAppConfiguration {
  name: string;

  src: string;

  serverSrc?: string;

  baseUrl?: string;

  css?: CssRef[];

  config?: unknown;

  trackingId?: string;

  anchorId?: string;

  legalEntity?: string;

  apiKey?: string;

  version?: string;
}

export interface FeatureappServiceOptions {
  [id: string]: FeatureAppConfiguration;
}

export interface AdditionalFeatureappServiceOptions {
  onAccess(
    consumerId: string,
    featureAppName: string | undefined,
    featureApp: FeatureAppConfiguration,
  ): void;
}

export function defineFeatureappService(
  options: FeatureappServiceOptions,
  additionalOptions?: AdditionalFeatureappServiceOptions,
): FeatureServiceProviderDefinition<FeatureappService> {
  return {
    id: 'featureapp-service',
    create: () => ({
      '1.6.0': (consumerId: string, consumerName?: string) => {
        const accessListener = additionalOptions
          ? (featureApp: FeatureAppConfiguration) => {
              additionalOptions.onAccess(consumerId, consumerName, featureApp);
            }
          : undefined;
        const featureAppConfigurations = createObservable(
          options,
          accessListener,
        );

        return {
          featureService: {
            featureAppConfigurations,
          },
        };
      },
    }),
  };
}
